/** Cadastro básico do paciente — conforme reunião: nome, CPF, telefone e e-mail bastam para iniciar a jornada. */
export interface Patient {
  id: string;
  nome: string;
  cpf: string;
  telefone: string;
  email: string;
  iniciais: string;
  queixaPrincipal: string;
  medicoResponsavel: string;
  dataInicioTratamento: string;
  faseAtual: DimaisLetter;
}

export type DimaisLetter = 'D' | 'I' | 'M' | 'A' | 'II' | 'S';

export const DIMAIS_LETTER_LABELS: Record<DimaisLetter, string> = {
  D: 'Diagnóstico',
  I: 'Intervenção',
  M: 'Monitoramento',
  A: 'Ajuste',
  II: 'Integração',
  S: 'Sustentação'
};
